import {styled} from "@mui/material/styles";
import { Box } from "@mui/material";


export const StyledBorderBox = styled(Box)({
   border: "1px solid rgba(0, 0, 0, 0.12)",
   marginTop: 2,
   marginBottom: 1,
});